export default __webpack_public_path__ + "static/media/port-cover.19a328d8.jpg";